import { CAMPAIGNS_LIST, EMAIL_LIST } from 'constants/types';
import { ICampaignItem, IDraftEmailItem } from 'modules/Content/interfaces';
import store from 'store';
import { IEmailItem, IVersion } from './interfaces';
import { css } from 'styled-components';

export enum AssetType {
  AI_EMAIL = 'ai-email',
}

export const aiEmailErrorMessages = [
  'Provide valid Audience for AI Email creation',
  'No new personality found!',
  'AI_GENERATIVE_EMAIL_API Failed!!',
  'Provide valid Audience for Audience segregation',
  'AI Emails Creation Unsuccessful!!',
];

export type personalities = 'Dominant' | 'Influencer' | 'Steady' | 'Conscientious' | 'Others';

export const audienceAIEmailEvents = {
  Dominant: 'ADVA',
  Influencer: 'AIVA',
  Steady: 'ASVA',
  Conscientious: 'ACVA',
  Others: 'AOVA',
};

export const editSubjectAIEmailEvents = {
  Dominant: 'ADES',
  Influencer: 'AIES',
  Steady: 'ASES',
  Conscientious: 'ACES',
  Others: 'AOES',
};

// serialize single article json to IArticleItem interface
export const serializeAssetDetails = (jsonData: any): any => {
  // let assetWithoutCampaign: any;
  let serializedData: any;
  let assetWithoutCampaign = jsonData;
  serializedData = {
    assetId: assetWithoutCampaign['asset_id'],
    assetName: assetWithoutCampaign['asset_name'],
    assetType: assetWithoutCampaign['asset_type'],
    assetKeywords: assetWithoutCampaign['asset_keywords'],
    isActive: assetWithoutCampaign['is_active'],
  };
  return serializedData;
};

export const serializeVersions = (jsonData: any[]): any[] => {
  let serializedData: IVersion[] = [];
  let editions = jsonData;
  for (let edition of editions) {
    serializedData.push({
      a_or_b: edition['a_or_b'],
      curated_articles_count: edition['curated_articles_count'],
      last_update: edition['last_update'],
      name: edition['name'],
      sent_date: edition['sent_date'],
      status: edition['status'],
      thumbnail: edition['thumbnail'],
      total_clicks: edition['total_clicks'],
      total_contacts: edition['total_contacts'],
      total_delivery: edition['total_delivery'],
      total_open: edition['total_open'],
      total_sent: edition['total_sent'],
      version_id: edition['version_id'],
      subject: edition['subject'],
      link: edition['link'],
      workflowStatus: edition['workflow_status'],
    });
  }
  return serializedData;
};

export const serializeDraftEmails = (jsonData: any) => {
  let serializedData = [] as IDraftEmailItem[];
  for (let item of jsonData) {
    serializedData.push({
      emailId: item['email_id'],
      thumbnails: item['thumbnails'],
      name: item['name'],
      type: item['email_type'],
      lastUpdate: item['last_updated'],
      workflowStatus: item['workflow_status'],
      workflowCurrentState: item['workflow_current_state'],
      workflowId: item['workflow_id'],
      generationId: item['generation_id'],
      aiType: item['ai_type'],
      aiColor: item['ai_color'],
    });
  }
  return serializedData;
};

export const serializeDraftEmailResponse = (item: any) => {
  let serializedData: IDraftEmailItem = {
    emailId: item['email_id'],
    thumbnails: item['thumbnails'],
    name: item['name'],
    type: item['email_type'],
    articlesCount: item['articles_count'] ?? 0,
    lastUpdate: item['last_update'],
  };

  return serializedData;
};

export const serializeVersion = (jsonData: any): any => {
  let serializedData = {} as IVersion;
  let edition = jsonData;
  serializedData = {
    a_or_b: edition['a_or_b'],
    curated_articles_count: edition['curated_articles_count'],
    last_update: edition['last_update'],
    name: edition['name'],
    sent_date: edition['sent_date'],
    status: edition['status'],
    thumbnail: edition['thumbnail'],
    total_clicks: edition['total_clicks'],
    total_contacts: edition['total_contacts'],
    total_delivery: edition['total_delivery'],
    total_open: edition['total_open'],
    total_sent: edition['total_sent'],
    version_id: edition[''],
    subject: edition['subject'],
    cloned: false,
  };
  return serializedData;
};

//* Serialize Newly created asset in Asset Browser to the
//* Asset in Campaign

export const browserAssetToCampaignAsset = (jsonData: any, campaignId: any): any => {
  let serializedData = {};
  let asset = jsonData;
  serializedData = {
    asset_id: asset?.asset_id,
    thumbnails: asset?.thumbnails,
    name: asset?.name,
    asset_type: 'Hybrid',
    last_update: asset?.last_update,
    total_contacts: 0,
    total_sent: 0,
    total_delivered: 0,
    total_open: 0,
    total_clicks: 0,
    campaign_id: campaignId,
    articles_count: asset?.total_curated_articles,
  };
  return serializedData;
};

// asset_id(pin):11215
// name(pin):"Draft Asset"
// asset_type(pin):null
// last_update(pin):"4 minutes ago"
// campaign_name(pin):"New Campaign Name here"
// campaign_id(pin):5296
// created_on(pin):"09 Sep"

export const createNewCampaignSerialize = (jsonData: any, emailCount?: number): any => {
  let campaign = jsonData;
  let serializedData = {
    campaign_id: campaign?.campaign_id,
    thumbnails: campaign?.thumbnails || [],
    name: campaign?.campaign_name,
    emails_count: emailCount !== undefined ? emailCount : 0,
    last_update: campaign?.updated_on,
    total_contacts: 0,
    total_sent: 0,
    total_delivered: 0,
    total_open: 0,
    total_clicks: 0,
  };
  return serializedData;
};

export const serializeEmails = (jsonData: any): IEmailItem[] => {
  let emails: IEmailItem[] = [];
  for (let email of jsonData) {
    emails.push({
      emailId: email['email_id'],
      name: email['name'],
      subject: email['email_subject'],
      articlesCount: email['articles_count'],
      campaignId: email['campaign_id'],
      campaignName: email['campaign_name'],
      thumbnails: email['image'] ?? email['thumbnails'] ?? [],
      lastUpdate: email['last_updated'],
      createdOn: email['created_on'],
      emailType: email['email_type'],
    });
  }

  return emails;
};

export const resetAllData = (prevCampaignId?: number, campaignId?: number) => {
  store.dispatch({
    type: CAMPAIGNS_LIST.PREV_ID,
    payload: 0,
  });

  store.dispatch({
    type: EMAIL_LIST.DRAFT_EMAILS_RESET_LOAD,
    payload: true,
  });
  store.dispatch({
    type: EMAIL_LIST.SENT_RESET,
  });
  store.dispatch({
    type: EMAIL_LIST.RESET_CAMPAIGN_DETAILS,
  });
  store.dispatch({
    type: EMAIL_LIST.GRAPH_CLEAR,
  });

  if (prevCampaignId !== campaignId || prevCampaignId === undefined || campaignId === undefined)
    store.dispatch({
      type: EMAIL_LIST.RESET,
      payload: true,
    });
};

export const resetDraftEmails = () => {
  store.dispatch({
    type: EMAIL_LIST.RESET,
    payload: true,
  });
};

export const splitDayMonth = (sent_date: any) => {
  if (!sent_date) return { month: '', date: '' };
  const myArr = sent_date?.split(',')[0].split(' ');
  return { month: myArr[0].toString(), date: myArr[1].toString() };
};

export const scrollbar = css`
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 4px;
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #001760;
    border-radius: 12px;
  }

  &::-webkit-scrollbar-track {
    background: #cfdae8;
  }
  & {
    scrollbar-face-color: #001760;
    border-radius: 12px;
  }
`;
